import { render } from "./sop.vue?vue&type=template&id=5ddd2e2e&scoped=true"
import script from "./sop.vue?vue&type=script&lang=js"
export * from "./sop.vue?vue&type=script&lang=js"

import "./sop.vue?vue&type=style&index=0&id=5ddd2e2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddd2e2e"]])

export default __exports__